// extracted by mini-css-extract-plugin
export default {"desktopModal":"Z63oP"};